import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
// import { AllLoadingEquipmentClearenceReport } from "../../../Apis/TransferStationReport/primaryDeploymentTransactionReportApi";
import {
  AllLoadingEquipment,
  AllLoadingEquipmentCertificationReport,
} from "../../../Apis/loadingEquipmentApi";
import TableComponent from "../../../Common/TableComponent/tableComponent";
import Loader from "../../../Common/Loader/loader";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { CreatableSelect } from '@atlaskit/select';
import { AllOwnerTypeDetails } from "../../../Apis/ownerTypeApi";
import { AllVehicleTypeDetails } from "../../../Apis/vehicleApi";
import { AllShiftMaster } from "../../../Apis/shiftMasterApi";
import { Height } from "@mui/icons-material";
import { Circle } from "react-feather";
import isGHMC from "../../../Common/helper/helpar";
import { getNowDateTime, getOneMonthPastDateTime } from "../../AssetVehicle/utils/helpers";
import TableSkeleton from "../../AllotedMaster/TableSkeleton";
const LoadingEquipmentCertificationReport = ({ t }) => {
  const headers = [
    "corporation",
    "Zone",
    "Circle",
    "Shift",
    "loadingEquipment",
    "ownerType",
    "vehicleType",
    "startShiftAndTime",
    "endShiftAndTime",
    "firstgvpstarttime",
    "lastgvpendtime",
    "TotalShiftHours",
    "TotalWorkingHours",
    "certifiedHours",
    "breakdownHours",
    "lateReporting",
    "earlyLeaving",
    "totaldeducationhourspqr"
  ];

  const [getAllTripsTonnage, setAllTripsTonnage] = useState([]);
  const [startDate, setStartDate] = useState(getStartOfCurrentDate());
  const [endDate, setEndDate] = useState(getCurrentDateTime());
  const [isLoading, setIsLoading] = useState(false);
  const [shiftType, setShiftType] = useState([]);
  const [ownerTypeDetails, setOwnerTypeDetails] = useState([]);
  const [selectedVehicleType, setSelectedVehicleType] = useState([]);
  const [vehicleTypeOptionsValues, setVehicleTypeOptionsValues] = useState([]);
  const [vehicleTypeDetails, setVehicleTypeDetails] = useState([]);
  const [optionsValues, setOptionsValues] = useState([]);
  const [optionsLoadingValues, setOptionLoadingValues] = useState([]);
  const [selectedOwnerType, setSelectedOwnerType] = useState([]);
  const [loadingEquipments, setLoadingEquipments] = useState([]);
  const [selectedLoadingEquipment, setSelectedLoadingEquipment] = useState([]);
  const [opts, setOpts] = useState(optionsLoadingValues);
  const [selectedShift, setSelectedShift] = useState("");
  const isProd = isGHMC();
  useEffect(() => {
    fetchTripsTonnageData(startDate, endDate);
  }, []);

  console.log(selectedShift)

  useEffect(() => {
    const fetchOwnerTypeData = async () => {
      try {
        const ownerTypeData = await AllOwnerTypeDetails();
        setOwnerTypeDetails(ownerTypeData);
      } catch (error) {
        console.error("Error fetching owner type data:", error);
      }
    };

    fetchOwnerTypeData();
  }, []);

  useEffect(() => {
    const fetchVehicleTypeData = async () => {
      try {
        const vehicleTypeData = await AllVehicleTypeDetails();
        setVehicleTypeDetails(vehicleTypeData);
      } catch (error) {
        console.error("Error fetching owner type data:", error);
      }
    };

    fetchVehicleTypeData();
  }, []);

  useEffect(() => {
    const fetchLoadingEquipments = async () => {
      try {
        const loadingEquipmentsData = await AllLoadingEquipment();
        setLoadingEquipments(loadingEquipmentsData);
      } catch (error) {
        console.error("Error fetching loading equipments:", error);
      }
    };

    fetchLoadingEquipments();
  }, []);

  useEffect(() => {
    const fetchShiftData = async () => {
      try {
        const shiftData = await AllShiftMaster();
        setShiftType(shiftData);
        // Default select the first shift if available
        // if (shiftData.length > 0) {
        //   setSelectedShift(shiftData[2].shiftId);
        // }
      } catch (error) {
        console.error("Error fetching shift data:", error);
      }
    };

    fetchShiftData();
  }, []);

  useEffect(() => {
    setVehicleTypeOptionsValues(vehicleTypeDetails.map(vehicleType => ({
      value: vehicleType.vehicleTypeId,
      label: vehicleType.vehicleTypeName,
    })));
  }, [vehicleTypeDetails]);

  const handleVehicleTypeChange = (newValue, actionMeta) => {
    if (actionMeta.action === 'select-option') {
      setSelectedVehicleType(newValue.value);
    } else if (actionMeta.action === 'create-option') {
      const newValueOption = { label: newValue.label, value: newValue.value };
      setSelectedVehicleType(newValue.value);
      // Add logic to update optionsValues with the new option if needed
    } else {
      if (actionMeta.action === 'clear') {
        setSelectedVehicleType(null); // Ensure selectedOwnerType is cleared
      }
    }
  };

  const fetchTripsTonnageData = async (startDate, endDate) => {
    try {
      setIsLoading(true);
      const response = await AllLoadingEquipmentCertificationReport(
        startDate,
        endDate,
        selectedOwnerType,
        selectedVehicleType,
        selectedLoadingEquipment,
        selectedShift // Include the selected shift ID
      );
      const formattedData = response.map((item) => ({
        ...item,
        corporation: item.corporationName || "N/A",
        Zone: item.zoneName || "N/A",
        Circle: item.circleName || "N/A",
        Shift: item.shift || "N/A",
        loadingEquipment: item.loadingEquipmentNumber || "N/A",
        ownerType: item.ownerType || "N/A",
        vehicleType: item.vehicleTypeName || "N/A",
        startShiftAndTime: item.startShiftDate || "N/A",
        firstgvpstarttime: item.firstGVPStartTime || "N/A",
        lastgvpendtime: item.lastGVPEndTime || "N/A",
        TotalShiftHours: item.totalShiftHours||"N/A",
        TotalWorkingHours: item.workedHours,
        endShiftAndTime: item.endShiftDateTime || "N/A",
        certifiedHours: item.certifiedHours,
        workedHours: item.workedHours,
        breakdownHours: item.breakdownHours,
        lateReporting: item.lateReportTime || "N/A",
        earlyLeaving: item.earlyLeaveTime || "N/A",
        totaldeducationhourspqr: item.totalDeductionHoursPQR || "N/A"
      }));
      setAllTripsTonnage(addTotalRow(formattedData));
      setIsLoading(false); // After data fetching is done, set isLoading to false
    } catch (error) {
      console.log(error);
      setIsLoading(false); // In case of error, also set isLoading to false
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    fetchTripsTonnageData(
      startDate,
      endDate,
      selectedOwnerType,
      selectedVehicleType,
      selectedLoadingEquipment,
      selectedShift
    );
  };


  const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
  const generationTime = ` ${new Date().toLocaleString('en-GB', options).replace(/\//g, '/')}`;


  const timeToSeconds = (time) => {
    if (!time) return 0; // Handle empty values
    const parts = time.split(":").map(Number);
    if (parts.length === 3) {
      return parts[0] * 3600 + parts[1] * 60 + parts[2]; // HH:mm:ss
    } else if (parts.length === 2) {
      return parts[0] * 60 + parts[1]; // mm:ss
    }
    return 0;
  };
 
  // Convert total seconds back to HH:mm:ss format
  const secondsToTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs.toString().padStart(2, "0")}:${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };
 
 
  // Function to calculate totals (including time-based fields)
  const calculateTotals = (data) => {
    return data.reduce(
      (totals, row) => {
        totals.TotalShiftHours += timeToSeconds(row.TotalShiftHours);
        totals.TotalWorkingHours += timeToSeconds(row.TotalWorkingHours);
        totals.certifiedHours += timeToSeconds(row.certifiedHours);
        totals.breakdownHours += timeToSeconds(row.breakdownHours);
        totals.lateReporting += timeToSeconds(row.lateReporting);
        totals.earlyLeaving += timeToSeconds(row.earlyLeaving);
        totals.totaldeducationhourspqr += timeToSeconds(row.totaldeducationhourspqr);
        return totals;
      },
      {
        TotalShiftHours: 0,
        TotalWorkingHours: 0,
        certifiedHours:0,
        breakdownHours:0,
        lateReporting:0,
        earlyLeaving:0,
        totaldeducationhourspqr:0

      }
    );
  };
 
  // Add a total row with properly formatted time values
  const addTotalRow = (data) => {
    if (!data.length) return data;
 
    const totals = calculateTotals(data);
 
    return [
      ...data,
      {
        lastgvpendtime: "Total",
        TotalShiftHours: secondsToTime(totals.TotalShiftHours),
        TotalWorkingHours: secondsToTime(totals.TotalWorkingHours),
        certifiedHours: secondsToTime(totals.certifiedHours),
        breakdownHours: secondsToTime(totals.breakdownHours),
        lateReporting: secondsToTime(totals.lateReporting),
        earlyLeaving: secondsToTime(totals.earlyLeaving),
        totaldeducationhourspqr: secondsToTime(totals.totaldeducationhourspqr),
      },
    ];
  };
// const displayedRows = [...getAllTripsTonnage, addTotalRow];

  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `Loading Equipment Certification Report`;
    const downloadDateTime = `Loading Equipment Certification Report Generated on: ${generationTime},${formattedTime}`;
    // Calculate the length of the downloadDateTime string
    const downloadDateTimeLength = downloadDateTime.length;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");
    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", downloadDateTime, ""]); // Update array length to match new cell range
    worksheet.mergeCells(1, 2, 1, 12); // Merge cells for downloadDateTime from column 2 to 4
    worksheet.getCell(1, 2).value = downloadDateTime; // Ensure the value is set after merging
    worksheet.getCell(1, 2).font = boldFont; // Set font style
    worksheet.getCell(1, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B1, C1, D1)
    for (let col = 2; col <= 12; col++) {
      worksheet.getCell(1, col).font = boldFont; // Set styles individually
      worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // Add "Zone Details" to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", "Loading Equipment Certification Report", ""]); // Update array length to match new cell range
    worksheet.mergeCells(2, 2, 2, 12); // Merge cells for Zone Details from column 2 to 4
    worksheet.getCell(2, 2).value = "Loading Equipment Certification Report"; // Ensure the value is set after merging
    worksheet.getCell(2, 2).font = boldFont; // Set font style
    worksheet.getCell(2, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B2, C2, D2)
    for (let col = 2; col <= 12; col++) {
      worksheet.getCell(2, col).font = boldFont; // Set styles individually
      worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
    }


    // Add empty row for spacing
    worksheet.addRow([""]);
    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "corporation",
      "Zone",
      "Circle",
      "Shift",
      "Loading Equipment",
      "Owner Type",
      "Vehicle Type",
      "Start Shift And Time",
      "End Shift And Time",
      "First GVP Start Time",
      "Last GVP End Time",
      "Total Shift Hours",
      "Total Working Hours",
      "Certified Hours",
      "Breakdown Hours",
      "Late Reporting",
      "Early Leaving",
      "Total Deduction Hours"
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" }; // Left align the cell content
      if (colNumber >= 1 && colNumber <= 21) {
        // Apply background color only to specific cells
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" } // Red background color
        };
      }
    });

    // Add data rows
    getAllTripsTonnage.forEach((item, index) => {
      worksheet.addRow([
        index + 1,
        item. corporationName ?? "N/A",
        item.zoneName?? "N/A",
        item.circleName?? "N/A",
        item.shift?? "N/A",
        item.loadingEquipmentNumber?? "N/A",
        item.ownerType?? "N/A",
        item.vehicleTypeName?? "N/A",
        item.startShiftDate?? "N/A",
        item.endShiftDateTime?? "N/A",
        item.firstGVPStartTime?? "N/A",
        item.lastgvpendtime?? "N/A",
        item.TotalShiftHours?? "N/A",
        item.TotalWorkingHours?? "N/A",
        item.certifiedHours?? "N/A",
        // item.workedHours,
        item.breakdownHours?? "N/A",
        item.lateReporting?? "N/A",
        item.earlyLeaving?? "N/A",
        item.totaldeducationhourspqr?? "N/A"

      ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber >= 1 && colNumber <= 21) {
          // Align the columns from 1 to 4 to the left
          cell.alignment = { horizontal: "left" };
        } else {
          // Align the rest of the columns to the center
          cell.alignment = { horizontal: "center" };
        }
      });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "LoadingEquipmentCertificationReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  useEffect(() => {
    setOptionsValues(ownerTypeDetails
      .filter((ownerType) => ownerType.isActive)
      .map(ownerType => ({
        value: ownerType.ownerTypeId,
        label: ownerType.ownerTypeName,
      })));
  }, [ownerTypeDetails]);


  useEffect(() => {
    setOptionLoadingValues(loadingEquipments
      .filter((LoadingEquipment) => LoadingEquipment.isActive)
      .map(LoadingEquipment => ({
        value: LoadingEquipment.loadingEquipmentId,
        label: LoadingEquipment.loadingEquipmentNumber,
      })));
  }, [loadingEquipments]);


  useEffect(() => {
    localStorage.setItem('selectedOwnerType', selectedOwnerType);
  }, [selectedOwnerType]);


  useEffect(() => {
    localStorage.setItem('setSelectedLoadingEquipment', setSelectedLoadingEquipment);
  }, [setSelectedLoadingEquipment]);


  const handleChange = (newValue, actionMeta) => {
    if (actionMeta.action === 'select-option') {
      setSelectedOwnerType(newValue.value);
    } else if (actionMeta.action === 'create-option') {
      const newValueOption = { label: newValue.label, value: newValue.value };
      setSelectedOwnerType(newValue.value);
      // Add logic to update optionsValues with the new option if needed
    } else {
      if (actionMeta.action === 'clear') {
        setSelectedOwnerType(null); // Ensure selectedOwnerType is cleared
      }
    }
  };
  const handleLoadingEquipmentChange = (newValue, actionMeta) => {
    if (actionMeta.action === 'select-option') {
      setSelectedLoadingEquipment(newValue.value);
    } else if (actionMeta.action === 'create-option') {
      const newValueOption = { label: newValue.label, value: newValue.value };
      setSelectedLoadingEquipment(newValue.value);
      // Add logic to update optionsValues with the new option if needed
    } else {
      if (actionMeta.action === 'clear') {
        setSelectedLoadingEquipment(null); // Ensure selectedOwnerType is cleared
      }
    }
  };

  const handleCreateOption = (inputValue) => {
    if (inputValue) {
      const newValue = { label: inputValue, value: inputValue.toLowerCase() };
      setOpts((prevOptions) => [...prevOptions, newValue]);
      if (typeof selectedLoadingEquipment === 'function') {
        selectedLoadingEquipment(newValue.value);
      } else {
        console.error('selectedLoadingEquipment is not a function');
      }
    }
  };
  return (
    <>
     
        <div style={{ width: "100%" }}>
          <div className="content">
            <div className="page-content">
              <h4 class="text-start mb-3">{t("Loading Equipment Certification")}  </h4>
              <div className="card">
                <div className="card-body p-3">
                  <div className="row align-items-end">
                    <div className="col-md-12">
                      <form className='row align-items-end'
                        onSubmit={handleFormSubmit}
                        style={{ textAlign: "justify" }}
                      >
                        <div className="col-md-2">
                          <label> From Date:</label>
                          <input
                            type="datetime-local"
                            name="FromDate"
                            style={inputStyle}
                            value={startDate}
                            className='form-control'
                            min={getOneMonthPastDateTime()}
                            max={getNowDateTime()}
                            onChange={(e) => setStartDate(e.target.value)}
                          />
                        </div>
                        <div className="col-md-2">
                          <label> To Date:</label>
                          <input
                            type="datetime-local"
                            name="ToDate"
                            style={inputStyle}
                            value={endDate}
                            className="form-control"
                            min={startDate}
                            max={getCurrentDateTime()}
                            onChange={(e) => setEndDate(e.target.value)}
                          />
                        </div>
                        <div className="col-md-2">
                          <label htmlFor="OwnerType">Owner Type:</label>
                          <CreatableSelect style={{ Height: '34px !important' }}
                            classNamePrefix="CreatableSelect"
                            inputId="ownerType"
                            name="ownerTypeId"
                            id="ownerType"
                            placeholder="Select"
                            options={optionsValues}
                            isClearable={true}
                            onChange={handleChange}
                            onCreateOption={(inputValue) => {
                              const newValue = { label: inputValue, value: inputValue.toLowerCase() };
                              { inputValue && newValue ? (setSelectedOwnerType(newValue.value)) : setSelectedOwnerType("  "); }
                              // setSelectedOwnerType(newValue.value);
                              // Add logic to update optionsValues with the new option if needed
                            }}
                            value={optionsValues.find((option) => option.value === selectedOwnerType)}
                          />
                        </div>
                        <div className="col-md-2">
                          <label htmlFor="VehicleType">Vehicle Type:</label>
                          <CreatableSelect style={{ Height: '34px !important' }}
                            classNamePrefix="CreatableSelect"
                            inputId="vehicleType"
                            name="vehicleTypeId"
                            id="vehicleType"
                            placeholder="Select"
                            options={vehicleTypeOptionsValues}
                            isClearable={true}
                            onChange={handleVehicleTypeChange}
                            onCreateOption={(inputValue) => {

                              const newValue = { label: inputValue, value: inputValue.toLowerCase() };
                              { inputValue && newValue ? (setSelectedVehicleType(newValue.value)) : setSelectedVehicleType("  "); }
                              // setSelectedOwnerType(newValue.value);
                              // Add logic to update optionsValues with the new option if needed
                            }}
                            value={vehicleTypeOptionsValues.find((option) => option.value === selectedVehicleType)}
                          />
                        </div>
                        <div className="col-md-2">
                          <label htmlFor="loadingEquipment" style={{ textAlign: 'left' }}>
                            Loading Equipment Number
                          </label>
                          <CreatableSelect style={{ Height: '34px !important' }}
                            classNamePrefix="CreatableSelect"
                            inputId="loadingEquipmentId"
                            name="loadingEquipmentId"
                            id="loadingEquipment"
                            placeholder="Select"
                            options={optionsLoadingValues}
                            isClearable={true}
                            onChange={handleLoadingEquipmentChange}
                            onCreateOption={handleCreateOption}
                            // onCreateOption={(inputValue) => {
                            //   const newValue = { label: inputValue, value: inputValue.toLowerCase() };
                            //   { inputValue && newValue ? (selectedLoadingEquipment(newValue.value)) : selectedLoadingEquipment("  "); }
                            //   // setSelectedOwnerType(newValue.value);
                            //   // Add logic to update optionsValues with the new option if needed
                            // }}
                            value={optionsLoadingValues.find((option) => option.value === selectedLoadingEquipment)}
                          />
                        </div>
                        <div className="col-md-2">
                          <label htmlFor="shift">Shift:</label>
                          <select
                            className="form-select"
                            style={inputStyle2}
                            name="shiftId"
                            id="shift"
                            value={selectedShift} // You can set a selected shift if needed
                            onChange={(e) => setSelectedShift(e.target.value)} // Handle selection if needed
                          >
                            <option value="">Select</option>
                            {shiftType
                              .filter((shift) => shift.isActive)
                              .map((shift) => (
                                <option key={shift.shiftId} value={shift.shiftId}>
                                  {shift.shiftName}
                                </option>
                              ))}
                          </select>
                        </div>
                        <div className="col-md-12 mt-2 d-flex justify-content-end mt-2" >
                          <button
                            type="submit"
                            className={`btn  ${isProd ? "search-ghmc" : "search-swm"}`}>
                            Search
                          </button>
                        
                          
                          <button className='btn-excel' onClick={downloadAsExcel} style={{ fontSize: '14px' }}>
                        <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                      </button>
                        </div>

                      </form>
                    </div>

                    {/* <div className="">
                      <button className='btn-excel ms-auto mt-4' onClick={downloadAsExcel} style={{ fontSize: '14px' }}>
                        <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                      </button>
                    </div> */}

                  </div>
                  <div className="mt-3">
                   { isLoading ? <TableSkeleton /> : <TableComponent
                      hasTotalRow
                      DataFetchURL={getAllTripsTonnage}
                      headers={headers}
                      // footerCount={true}
                    />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      
    </>
  );
};

// Rest of the component remains the same

export default withTranslation()(LoadingEquipmentCertificationReport);

// Styles for input and button

const inputStyle = {
  border: "1px solid #E2E2E2",
};

const inputStyle2 = {
  border: "1px solid #E2E2E2",
};

const buttonStyle = {
  border: "1px solid #E2E2E2",
  borderRadius: "5px",
  color: "#fff",
};

// Function to get the start of the current date (00:00 AM)
const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}`;
};
